import React, { useState } from 'react';
import styled from 'styled-components';
import toast from 'react-hot-toast';

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StatusIndicator = styled.div`
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  background: ${props => props.disabled ? '#f8d7da' : '#d4edda'};
  color: ${props => props.disabled ? '#721c24' : '#155724'};
  font-weight: 500;
  text-align: center;
`;

const WithdrawalForm = ({ disabled = false }) => {
  const [formData, setFormData] = useState({
    itemId: '',
    quantity: '',
    clientName: '',
    withdrawalReason: '',
    destinationAddress: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (disabled) return;

    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      toast.success('Withdrawal request submitted successfully');
      setFormData({
        itemId: '',
        quantity: '',
        clientName: '',
        withdrawalReason: '',
        destinationAddress: ''
      });
    } catch (error) {
      toast.error('Failed to process withdrawal request');
    }
  };

  return (
    <FormContainer>
      <StatusIndicator disabled={disabled}>
        {disabled 
          ? '🛑 Withdrawal operations are currently suspended'
          : '✅ Withdrawal operations are active'
        }
      </StatusIndicator>
      
      <p style={{ color: '#6c757d', textAlign: 'center' }}>
        Withdrawal form functionality will be implemented here.
        This includes token burning and physical commodity release workflows.
      </p>
    </FormContainer>
  );
};

export default WithdrawalForm; 